<template>
    <div class="miandiv">
        <div class="page">
            <img @click="closeme()" src="../assets/image/close.png">
            发布筛选
            <span>
                <select v-model="selectedOption" style="width: 70%;margin-top: 10px;background-color: white;height:30px" >
                    <option v-for="option in options" :value="option">{{option.name}}</option>
                </select>
            </span>
            <!-- <span><input type="text" title="关键词" class="input" style="width: 70%;margin-top: 5px;background-color: white;" 
                @ placeholder="请选择时间段"></span> -->
            <span>
                作者筛选
                <span><input type="text" title="关键词" class="input" style="width: 70%;margin-top: 10px;background-color: white;" 
                @ placeholder="请输入作者名称" v-model="authorname"></span>
            </span>
            <span>我的标签</span>
            <div style="width:230px">
                <div style="display: block;width: 60px;" class="lablewords" @click="allcheck()" :class="{active:allbtn}">全选</div>
                <ul >
                    <li v-for="(item,index) in ShowTagsList" class="lablewords" @click="CheckTags(item.Name)" :class="{active:activeList.includes(item.Name)}">
                        <span style="margin-bottom: 3px">{{item.Name}}</span></li>
                </ul>
            </div>
            <div style="width:230px">
                <button @click="searchlist()" class="btn selfbtn">确认</button><button @click="cancel()" class="btn selfbtn cancelbtn">取消</button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name:'SofaScreen',
    // props: {
    //     pid:Number,
    // },
    data(){
        return{
            selectedOption:{date:0,name:"今天"},
            options:[
                {
                    date:0,
                    name:"今天"
                },{
                    date:1,
                    name:"昨天"
                },{
                    date:7,
                    name:"近7天"
                },{
                    date:30,
                    name:"近30天"
                },{
                    date:90,
                    name:"近3个月"
                },{
                    date:180,
                    name:"近6个月"
                },{
                    date:360,
                    name:"近1年"
                }
            ],
            authorname:'',
            activeList:[],
            allbtn:false,
            // ShowTagsList:[]
        }
    },
    computed: {
        token:{
            get(){
                return this.$store.state.menu.token
            },
            set(val){
                this.$store.state.menu.token = val
            }
        },
        ShowTagsList:{
            get(){
                return this.$store.state.sofasniper.ShowTagsList
            },
            set(val){
                this.$store.state.sofasniper.ShowTagsList = val
            }
        },
    },
    methods:{
        closeme()
        {
            this.$emit("listenScreenEvent",false);
        },
        searchlist(){
            let tags='';
            for(let item of this.activeList)
            {
                if(tags=='')
                {
                    tags=item;
                }
                else
                {
                    tags=tags+'|'+item;
                }
            }
            let nowdate=this.getcheckdate(this.selectedOption.date).nowdate;
            let startdate= this.getcheckdate(this.selectedOption.date).startdate;

            let sendproms='&authorName='+this.authorname+'&tagName='+tags+'&publishStartDate='+startdate+'&publishEndDate='+nowdate;

             this.$emit("listenSendmsgEvent",sendproms);
        },
        CheckTags(name){
            if(this.activeList.includes(name)){
               let index = this.activeList.indexOf(name)
               index!=-1 && this.activeList.splice(index,1)
            }else{
                this.activeList.push(name);
            }
            
        },
        allcheck(){
            this.allbtn?this.allbtn=false:this.allbtn=true;
            this.activeList=[];
            if(this.allbtn){
                
                for(let item of this.ShowTagsList){
                    this.activeList.push(item.Name)
                }
            }
            
        },
        cancel(){
            this.allbtn=false;
            this.activeList = [];
            this.authorname ='';
            this.selectedOption={cityCode:0,city:"今天"};
        },
        getcheckdate(type){
            let date1 = new Date();
            let date2 = new Date(date1);
            let getnowdate=date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate();
            let startdate='';
            let returnmsg = {};
            if(type===0){
                date2.setDate(date1.getDate() + 1);
                startdate=getnowdate;
                getnowdate=date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate()
            }
            else if(type===1){
                date2.setDate(date1.getDate() - 1);
                startdate=date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate();
                getnowdate=date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate();
            }
            else{
                date2.setDate(date1.getDate() - type);
                startdate=date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate()
            }
            return returnmsg={startdate:startdate,nowdate:getnowdate}
            
        }
    },
    mounted(){
        
    }
    
}
</script>


<style type="text/less" lang="less" scoped>
    .miandiv{
        height: 100%;
        width: 100%;
        background-color: #ddedfb;
        position:fixed;
        padding-top: 20px;
        img{
            margin-left: 225px;
            position: absolute;
            margin-top: -10px;
            cursor: pointer;
        }
        span{
            display: block;
            margin-bottom: 20px;
        }
        .selfbtn{
            padding: 3px 30px;
            margin-left: 20px;
            margin-top: 20px
        }
        .cancelbtn{
            background-color: white;
            color: #166df1;
            border: 1px solid #166df1;
        }
        .lablewords{
            color: black;
            background-color: white;
            padding: 5px 15px;
            border-radius: 3px;
            margin-right: 5px;
            display:inline-block;
            margin-bottom:10px;
            cursor: pointer;
            &.active{
                background-color: #f49307;
                color: white;
            }
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SofaScreen.vue